export default __webpack_public_path__ + "static/media/gallery_09.525446e7.jpg";